import { createContext, useContext } from 'react';

import type { PlatformId, SiteId } from 'frontend-platform_detection';

interface Props {
  children: JSX.Element[] | JSX.Element
  platform: PlatformId
  site?: SiteId
}

export const platformContext = createContext<PlatformId | undefined>(undefined);

export const siteContext = createContext<SiteId | undefined>(undefined);

export const usePlatform = (): PlatformId | undefined => useContext(platformContext);

export const useSite = (): SiteId | undefined => useContext(siteContext);


const PlatfromWrapper = (props: Props): JSX.Element => {
  const { children, platform, site } = props;

  return (
    // TODO: Unificar ambas contexts.
    <platformContext.Provider value={platform}>
      <siteContext.Provider value={site}>
        {children}
      </siteContext.Provider>
    </platformContext.Provider>
  );
};

export default PlatfromWrapper;
